import React from 'react';
import { Box, Button, Typography } from '@mui/material';

interface MarketOption {
  label: string;
  price?: string;
}

interface LiveEventCardMarketSectionProps {
  title: string;
  option1: MarketOption | null | undefined;
  option2: MarketOption | null | undefined;
}

export function LiveEventCardMarketSection({
  title,
  option1,
  option2,
}: LiveEventCardMarketSectionProps) {
  if (!option1 && !option2) return null;

  return (
    <Box sx={{ mb: 1 }}>
      <Typography
        sx={{
          fontSize: '0.75rem',
          fontWeight: 700,
          color: 'text.secondary',
          textTransform: 'uppercase',
          mb: 0.75,
        }}
      >
        {title}
      </Typography>
      <Box sx={{ display: 'flex', gap: 0.75 }}>
        {option1 && (
          <Button
            size="small"
            variant="text"
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 1,
              px: 0.75,
              borderRadius: '8px',
              bgcolor: 'action.hover',
              border: 'none',
              minHeight: 56,
              textTransform: 'none',
              '&:hover': {
                bgcolor: 'action.selected',
                border: 'none',
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Typography
              sx={{
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: 'text.primary',
                mb: 0.25,
                textAlign: 'center',
                lineHeight: 1.2,
              }}
            >
              {option1.label}
            </Typography>
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 400,
                color: 'text.secondary',
                textAlign: 'center',
              }}
            >
              {option1.price || '0¢'}
            </Typography>
          </Button>
        )}
        {option2 && (
          <Button
            size="small"
            variant="text"
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 1,
              px: 0.75,
              borderRadius: '8px',
              bgcolor: 'action.hover',
              border: 'none',
              minHeight: 56,
              textTransform: 'none',
              '&:hover': {
                bgcolor: 'action.selected',
                border: 'none',
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Typography
              sx={{
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: 'text.primary',
                mb: 0.25,
                textAlign: 'center',
                lineHeight: 1.2,
              }}
            >
              {option2.label}
            </Typography>
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 400,
                color: 'text.secondary',
                textAlign: 'center',
              }}
            >
              {option2.price || '0¢'}
            </Typography>
          </Button>
        )}
      </Box>
    </Box>
  );
}
